// Status/Priority badges for Issues. Values are Dropdown Manager slugs, so we
// key colours on the known seeded slugs and fall back to a neutral style +
// humanised label for any custom value an admin later adds.

type BadgeStyle = { bg: string; fg: string; label: string };

function humanize(value: string): string {
  return value
    .replace(/[_-]+/g, " ")
    .replace(/\b\w/g, (c) => c.toUpperCase());
}

const STATUS_STYLES: Record<string, BadgeStyle> = {
  new: { bg: "hsl(210,55%,92%)", fg: "hsl(210,100%,28%)", label: "New" },
  in_progress: { bg: "hsl(38,92%,92%)", fg: "hsl(38,92%,30%)", label: "In Progress" },
  on_hold: { bg: "hsl(28,80%,92%)", fg: "hsl(28,80%,34%)", label: "On Hold" },
  resolved: { bg: "hsl(142,55%,92%)", fg: "hsl(142,72%,28%)", label: "Resolved" },
  closed: { bg: "hsl(215,16%,90%)", fg: "hsl(215,16%,38%)", label: "Closed" },
  rejected: { bg: "hsl(0,84%,95%)", fg: "hsl(0,72%,45%)", label: "Rejected" },
};

const PRIORITY_STYLES: Record<string, BadgeStyle> = {
  high: { bg: "hsl(0,84%,95%)", fg: "hsl(0,72%,45%)", label: "High" },
  medium: { bg: "hsl(38,92%,92%)", fg: "hsl(38,92%,30%)", label: "Medium" },
  low: { bg: "hsl(142,55%,92%)", fg: "hsl(142,72%,28%)", label: "Low" },
};

function Badge({ style }: { style: BadgeStyle }) {
  return (
    <span
      className="inline-flex items-center rounded-full px-2.5 py-0.5 text-[11px] font-medium"
      style={{ background: style.bg, color: style.fg }}
    >
      {style.label}
    </span>
  );
}

export function IssueStatusBadge({ status }: { status: string | null }) {
  if (!status) return <span className="text-muted-foreground">—</span>;
  const style =
    STATUS_STYLES[status] ?? {
      bg: "hsl(215,16%,90%)",
      fg: "hsl(215,16%,38%)",
      label: humanize(status),
    };
  return <Badge style={style} />;
}

export function PriorityBadge({ priority }: { priority: string | null }) {
  if (!priority) return <span className="text-muted-foreground">—</span>;
  const style =
    PRIORITY_STYLES[priority] ?? {
      bg: "hsl(215,16%,90%)",
      fg: "hsl(215,16%,38%)",
      label: humanize(priority),
    };
  return <Badge style={style} />;
}
